module.exports = __webpack_public_path__ + "files/1e181b967ead11bd7f131d3dc1531f6e.png";